import { MODAL_ACTION, useModalsContext } from '../../contexts/modals';
import { DeleteUsersInListModal } from './DeleteUsersInListModal';
import { ExportToFBCAModal } from './ExportToFBCAModal';
import { ExportToCSVModal } from './exportToCSVModal/ExportToCSVModal';
import { NewDynamicListModal } from './newList/NewDynamicListModal';
import { NewStaticListsModal } from './newList/NewStaticListsModal';
import { UpdateDynamicListQueryModal } from './UpdateDynamicListQueryModal';

export const SegmentationModals = () => {
  const { modalState } = useModalsContext();

  if (modalState === null) return null;

  const { action } = modalState;

  switch (action) {
    case MODAL_ACTION.DELETE_USERS:
      return <DeleteUsersInListModal />;
    case MODAL_ACTION.EXPORT_TO_CSV:
      return <ExportToCSVModal />;
    case MODAL_ACTION.EXPORT_TO_FBCA:
      return <ExportToFBCAModal />;
    case MODAL_ACTION.NEW_DYNAMIC_LIST:
      return <NewDynamicListModal />;
    case MODAL_ACTION.NEW_STATIC_LISTS:
      return <NewStaticListsModal />;
    case MODAL_ACTION.UPDATE_DYNAMIC_QUERY:
      return <UpdateDynamicListQueryModal />;

    default:
      return null;
  }
};
